module.exports = __webpack_public_path__ + "static/img/cont217.01a3ad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont217.jpg
// module id = 8lNt
// module chunks = 0